<template>
	<sidenav :groups="groups" :filteredGroups.sync="filterGroups" />
</template>

<script>
export default {
	name: "ReportingSidenav",
	props: ["filteredGroups"],
	data() {
		return {
			groups: {
				Auditing: [
					{
						name: "Audit Responses",
						path: "/auditing",
						permission: "page_auditing",
						icon: "fa-barcode-alt"
					},
					{
						name: "Audit Scores",
						path: "/score_auditing",
						permission: "page_auditing",
						icon: "fa-barcode-alt"
					}
					// {
					// 	name: "Reset History",
					// 	path: "/reset_history",
					// 	permission: "page_auditing",
					// 	icon: "fa-barcode-alt"
					// }
				],
				Reporting: [
					{
						name: "School Dashboard",
						path: "/dashboard/school",
						permission: "page_school_dashboard",
						icon: "fa-pencil-ruler"
					},
					{
						name: "Traffic Dashboard",
						path: "/dashboard/traffic",
						permission: "page_traffic_dashboard",
						icon: "fa-tachometer-alt"
					},
					{
						name: "Completion Report",
						path: "/reporting/completion",
						permission: "page_report_completion",
						icon: "fa-clipboard-list"
					},
					{
						name: "Scorers Report",
						path: "/reporting/scorers",
						permission: "page_report_scorers",
						icon: "fa-inventory"
					},
					// {
					// 	name: "Payroll Report",
					// 	path: "/reporting/payroll",
					// 	permission: "page_payroll",
					// 	icon: "fa-chart-bar"
					// },
					// {
					// 	name: "Daily Report",
					// 	path: "/reporting/daily",
					// 	permission: "page_reporting",
					// 	icon: "fa-chart-bar"
					// },
					// {
					// 	name: "User Summary",
					// 	path: "/reporting/user_summary",
					// 	permission: "page_reporting",
					// 	icon: "fa-chart-bar"
					// },
					{
						name: "Assessment Stats",
						path: "/reporting/assessment_summary",
						permission: "page_asmt_summary",
						icon: "fa-chart-bar"
					},
					{
						name: "User Agreement",
						path: "/reporting/user_agreement",
						permission: "page_user_agreement",
						icon: "fa-user-check"
					}
					// {
					// 	name: "Project Agreement",
					// 	path: "/reporting/project_agreement",
					// 	permission: "page_reporting",
					// 	icon: "fa-chart-bar"
					// }
				]
			},
			filterGroups: null
		};
	},
	created() {},
	mounted() {},
	beforeDestroy() {},
	destroyed() {},
	computed: {},
	watch: {
		filterGroups() {
			this.$emit("update:filteredGroups", this.filterGroups);
		}
	},
	methods: {}
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/global/ReportingSidenav.vue